import { combineReducers } from 'redux';

import consultaAnexosConsumidor from './consultaAnexosConsumidor/reducer';

export default combineReducers({
	consultaAnexosConsumidor,
});
